import PrimarySourceTag from "@/components/StatusTags/PrimarySourceTag/PrimarySourceTag";
import ProxyTag from "@/components/StatusTags/ProxyTag/ProxyTag";
import UnrelatedTag from "@/components/StatusTags/UnrelatedTag";
import Table from "@/components/Table/Table";
import useTableStateParams from "@/components/Table/hooks/useTableState";
import { productLabel } from "@/utilities/products";
import { useGetMaterialRelatedProducts } from "../useMaterials";

export default function MaterialRelatedProductsTable({ materialId }: { materialId: number }) {
  const { pagination, onSearchFilterSortPaginate } = useTableStateParams({
    defaultPagination: { page: 1, pageSize: 10 },
  });
  const { data, isLoading, isFetching } = useGetMaterialRelatedProducts({ materialId, pagination });
  const loading = isLoading || isFetching;

  return (
    <Table
      loading={loading}
      type="grey"
      emptyState={{ hide: true }}
      hideRaster={true}
      pagination={pagination}
      totalRows={data?.total_count}
      data={data?.related_products}
      onSearchFilterSortPaginate={onSearchFilterSortPaginate}
      rowLink={(record) => `/products/${record.id}/bom`}
      columns={[
        {
          label: "Product",
          key: "id",
          renderer: (record) => productLabel(record.external_id, record.name),
        },
        {
          label: "Relation",
          key: "proxy_weight",
          renderer: (record) => (
            <>
              {record.relation === "primary_source" ? <PrimarySourceTag /> : <ProxyTag />}
              {record.unrelated && <UnrelatedTag />}
            </>
          ),
        },
      ]}
      rowKey={"id"}
    />
  );
}
